export default __webpack_public_path__ + "static/media/sbernydvur.dfcc5bad.svg";